import styled from 'styled-components'

interface RootProps {
  color?: string
  variant?: 'bold' | 'thin'
  fillType?: 'semi' | 'none' | 'full'
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  href?: string
}

export const Root = styled.button<RootProps>((props) => ({
  margin: '0 2px',
  cursor: props.disabled ? 'not-allowed' : 'pointer',
  backgroundColor:
    props.fillType === 'full' && props.color
      ? props.color
      : props.fillType === 'semi' && props.color
      ? `${props.color}26`
      : '#FAFBFC',
  borderColor:
    props.fillType === 'full' && props.color
      ? props.color
      : props.fillType === 'semi' && props.color
      ? `${props.color}26`
      : props.color || '#DFE1E6',
  color:
    props.fillType === 'full' && props.color
      ? '#FFFFFF'
      : props.color || '#091E42',
  borderRadius: props.variant === 'bold' ? '12px' : '12px',
  borderWidth: '1px',
  borderStyle: 'solid',
  padding: props.size === 'small' ? `5px` : `8px 18px`,
  outline: 'none',
  fontWeight: 500,
  fontSize: '14px',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor:
      props.fillType === 'full' && props.color
        ? `${props.color}E6`
        : props.fillType === 'semi' && props.color
        ? `${props.color}33`
        : '#F4F5F7',
    borderColor:
      props.fillType === 'full' && props.color
        ? `${props.color}E6`
        : props.fillType === 'semi' && props.color
        ? `${props.color}33`
        : props.color || '#DFE1E6',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
}))

export const RootLink = styled.a<RootProps>((props) => ({
  margin: '0 2px',
  cursor: props.disabled ? 'not-allowed' : 'pointer',
  backgroundColor:
    props.fillType === 'full' && props.color
      ? props.color
      : props.fillType === 'semi' && props.color
      ? `${props.color}26`
      : '#FAFBFC',
  borderColor:
    props.fillType === 'full' && props.color
      ? props.color
      : props.fillType === 'semi' && props.color
      ? `${props.color}26`
      : props.color || '#DFE1E6',
  color:
    props.fillType === 'full' && props.color
      ? '#FFFFFF'
      : props.color || '#091E42',
  borderRadius: props.variant === 'bold' ? '12px' : '12px',
  borderWidth: '1px',
  borderStyle: 'solid',
  padding: props.size === 'small' ? `5px` : `8px 18px`,
  outline: 'none',
  fontWeight: 500,
  fontSize: '14px',
  whiteSpace: 'nowrap',
  '&:focus': {
    outline: 'none',
  },

  '&:hover': {
    textDecoration: 'none',
    color:
      props.fillType === 'full' && props.color
        ? '#FFFFFF'
        : props.color || '#091E42',
    backgroundColor:
      props.fillType === 'full' && props.color
        ? `${props.color}E6`
        : props.fillType === 'semi' && props.color
        ? `${props.color}33`
        : '#F4F5F7',
    borderColor:
      props.fillType === 'full' && props.color
        ? `${props.color}E6`
        : props.fillType === 'semi' && props.color
        ? `${props.color}33`
        : props.color || '#DFE1E6',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
}))
